import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axiosClient from "../common/api/request";
const data = {
  BUG: {
    title: "Report a Bug",
    text: "We're sorry to hear that you've encountered a bug on our platform. We're continuously working to improve it and we appreciate your patience during this phase. Could you kindly provide us with more details about the issue you've faced?",
  },
  CHAT: {
    title: "Chat support",
    text: "Thank you for reaching out to Career Scoops™ chat support! Please leave us a message, and an available Career Scoops representative will get back to you shortly. You can also reach us via text at (407) 205-7872.",
  },
  CONTACT: {
    title: "Contact us",
    text: "Please feel free to leave us a detailed message below, and we'll make sure to get back to you promptly. You can also reach us by phone at (407) 205-7872 or email us directly at info@career-scoops.com",
  },
};

const useFooter = () => {
  const { pathname } = useLocation();
  const [isModalOpened, setIsmoadlOpened] = useState(false);
  const [email, setEmail] = useState("");
  const [isSuccessModalOpened, setIsSuccessModalOpened] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [showError, setShowError] = useState(false);
  const [inviteObj, setInviteObj] = useState({});
  const closeModal = () => {
    setIsmoadlOpened(false);
  };
  const openModal = (type) => {
    setInviteObj({
      ...data[type],
      type,
    });
    setIsmoadlOpened(true);
  };
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const linksToScrollTop = [
      "/about",
      "/stories",
      "/faq",
      "/terms",
      "/privacypolicy",
    ];
    if (linksToScrollTop.some((link) => pathname.includes(link))) {
      scrollToTop();
    }
  }, [pathname]);
  const handleInput = (e) => {
    setEmail(e.target.value);
  };
  useEffect(() => {
    if (emailError) {
      setEmailError("");
      setShowError(false);
    }
  }, [email]);
  const subsCribe = () => {
    axiosClient
      .post("subscriptions/", {
        email,
      })
      .then(() => {
        openSuccessModal();
        setEmail("");
      })
      .catch(() => {
        //  console.log(response.response.data.email[0])
        closeSuccessModal();
      });
  };
  const checkEmail = (e) => {
    if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(e)) {
      setEmailError("Please enter a valid email address.");
      setShowError(true);
    } else {
      setEmailError(null);
      setShowError(false);
      subsCribe();
    }
  };
  const openSuccessModal = () => {
    setIsSuccessModalOpened(true);
  };
  const closeSuccessModal = () => {
    setIsSuccessModalOpened(false);
  };
  return {
    inviteObj,
    isModalOpened,
    closeModal,
    openModal,
    handleInput,
    email,
    subsCribe,
    isSuccessModalOpened,
    openSuccessModal,
    closeSuccessModal,
    checkEmail,
    showError,
    emailError,
  };
};
export default useFooter;
